
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { CheckCircle, Star } from "lucide-react";
import { Link } from "react-router-dom";

interface OfferHeaderProps {
  title: string;
  tags: string[];
  sellerName: string;
  sellerLogo: string;
  sellerVerified: boolean;
  sellerRating: string;
  reviewCount: number;
}

const OfferHeader = ({
  title,
  tags,
  sellerName,
  sellerLogo,
  sellerVerified,
  sellerRating,
  reviewCount,
}: OfferHeaderProps) => {
  return (
    <div className="mb-8">
      <h1 className="text-3xl font-bold mb-4">{title}</h1>
      <div className="flex flex-wrap gap-2 mb-6">
        {tags?.map((tag) => (
          <Badge key={tag} variant="outline" className="bg-primary/10 text-primary">
            {tag}
          </Badge>
        ))}
      </div>
      <div className="flex items-center gap-4">
        <Avatar className="h-10 w-10">
          <AvatarImage src={sellerLogo} alt={sellerName} />
          <AvatarFallback>
            {sellerName.slice(0, 2).toUpperCase()}
          </AvatarFallback>
        </Avatar>
        <div>
          <div className="flex items-center gap-2">
            <span className="font-medium">{sellerName}</span>
            {sellerVerified && (
              <CheckCircle className="h-4 w-4 text-blue-500" />
            )}
          </div>
          <div className="flex items-center gap-1 text-sm text-gray-500">
            <Star className="h-3 w-3 fill-yellow-400 text-yellow-400" />
            <span>{sellerRating}</span>
            <span>({reviewCount} reviews)</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfferHeader;
